import { Component, OnInit } from '@angular/core';
import { Environment_Service } from '../../../../../modules/system/services/Environment_Service';
import { Helper_Service } from '../../../services/Core/Helper_Service';

export interface Theme {
    theme_name: string;
    color: string;
    isDark?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
}

@Component({
    selector: 'mat-theme-picker',
    templateUrl: './Theme_Picker.html',
    styleUrls: ['./Theme_Picker.scss']
})
export class Theme_Picker_Component implements OnInit {
    storageKey = 'current_stored_theme';
    darkStorageKey = 'current_stored_dark';
    isDark: boolean = false;
    customStorageKey = 'current_stored_custom';
    customPrimary: string = '#6495ED';
    customAccent: string = '#6495ED';

    themes: Theme[] = [
        {
            theme_name: "cornflower",
            color: "#6495ED",
            isDark: false,
            isDefault: true,
            isActive: false
        },
        {
            theme_name: "slate",
            color: "#778899",
            isDark: false,
            isDefault: false,
            isActive: false
        },
        {
            theme_name: "lake",
            color: "#12535C",
            isDark: false,
            isDefault: false,
            isActive: false
        },
        {
            theme_name: "deeppink",
            color: "#FF1493",
            isDark: false,
            isDefault: false,
            isActive: false
        },
        {
            theme_name: "aquamarine",
            color: "#66CDAA",
            isDark: false,
            isDefault: false,
            isActive: false
        },
        {
            theme_name: "red",
            color: "#d50000",
            isDark: false,
            isDefault: false,
            isActive: false
        },
        {
            theme_name: "grey",
            color: "#37474f",
            isDark: false,
            isDefault: false,
            isActive: false
        }
    ];

    constructor(private helper_service: Helper_Service, private environment_service: Environment_Service) { }
 
    ngOnInit() {
        if (this.environment_service.environment.environment_name.toLowerCase().includes('aat')) {
            this.themes = [
                { theme_name: "cornflower", color: "#6495ED", isDark: false, isDefault: true, isActive: false },
                { theme_name: "slate", color: "#778899", isDark: false, isDefault: false, isActive: false },
                { theme_name: "lake", color: "#12535C", isDark: false, isDefault: false, isActive: false },
                { theme_name: "deeppink", color: "#FF1493", isDark: false, isDefault: false, isActive: false },
                { theme_name: "aquamarine", color: "#66CDAA", isDark: false, isDefault: false, isActive: false },
                { theme_name: "red", color: "#d50000", isDark: false, isDefault: false, isActive: false },
                { theme_name: "grey", color: "#37474f", isDark: false, isDefault: false, isActive: false },
                { theme_name: "rainbow", color: "conic-gradient(#a43535, #ff7b00, #ffff51, #a7ff4e, #7addfe, #6b6bfd, #ca61ff, #ff54af, #f3bbff, #a43535)", isDark: false, isDefault: false, isActive: false }            ];
        } else {
            this.themes = [
                { theme_name: "indigo", color: "#3f51b5", isDark: false, isDefault: true, isActive: false },
                { theme_name: "orange", color: "#ff9800", isDark: false, isDefault: false, isActive: false },
                { theme_name: "green", color: "#43a047", isDark: false, isDefault: false, isActive: false },
                { theme_name: "brown", color: "#795548", isDark: false, isDefault: false, isActive: false },
                { theme_name: "red", color: "#d50000", isDark: false, isDefault: false, isActive: false },
                { theme_name: "pink", color: "#f50057", isDark: false, isDefault: false, isActive: false },
                { theme_name: "grey", color: "#212121", isDark: false, isDefault: false, isActive: false },
                { theme_name: "rainbow", color: "conic-gradient(#a43535, #ff7b00, #ffff51, #a7ff4e, #7addfe, #6b6bfd, #ca61ff, #ff54af, #f3bbff, #a43535)", isDark: false, isDefault: false, isActive: false }            ];
        }
        
        this.isDark = this.getStoredDark();
        if (this.isDark) {
            document.body.classList.add('dark');
        }

        const storedCustom = this.getStoredCustom();
        if (storedCustom) {
            this.customPrimary = storedCustom.primary;
            this.customAccent = this.lightenHex(this.customPrimary, 0.4);
        }

        const storeTheme = this.getStoredTheme();
        if (storeTheme == null) {
            //Inject Default Theme
            this.themes.forEach(theme => {
                if (theme.isDefault == true) {
                    this.applyTheme(theme);
                }
            });
        } else if (storeTheme.theme_name === 'custom') {
            this.injectCustomStyles(this.customPrimary, this.customAccent);
            this.applyTheme(storeTheme);
        } else if (storeTheme.theme_name === 'rainbow') {
            this.injectRainbowStyles();
            this.applyTheme(storeTheme);
        } else {
            this.applyTheme(storeTheme);
        }
    }

    onChangeTheme(theme: Theme) {
        const oldTheme = this.getStoredTheme();
        this.helper_service.toggleRighSideNav();
        this.removeTheme(oldTheme);

        if (theme.theme_name === 'rainbow') {
            this.injectRainbowStyles();
        }

        this.applyTheme(theme);
        this.storeTheme(theme);
    }

    applyTheme(theme: Theme) {
        try {
            // mark the theme as active
            this.themes.forEach(obj => {
                if (obj.theme_name == theme.theme_name) {
                    obj.isActive = true;
                }
                else {
                    obj.isActive = false;
                }
            });
            // appy theme
            document.body.classList.add(theme.theme_name);

        } catch (e) { }
    }

    removeTheme(theme: Theme) {
        try {
            document.body.classList.remove(theme.theme_name);
        } catch (e) { }
    }

    storeTheme(theme: Theme) {
        try {
            window.localStorage[this.storageKey] = JSON.stringify(theme);
        } catch (e) { }
    }

    getStoredTheme(): Theme {
        try {
            return JSON.parse(window.localStorage[this.storageKey] || null);
        } catch (e) {
            return null;
        }
    }
    clearStorageTheme() {
        try {
            window.localStorage.removeItem(this.storageKey);
        } catch (e) { }
    }

    onToggleDark(event: any) {
        this.isDark = event.checked;
        if (this.isDark) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
        this.storeDark(this.isDark);
    }

    storeDark(isDark: boolean) {
        try {
            window.localStorage[this.darkStorageKey] = JSON.stringify(isDark);
        } catch (e) { }
    }

    getStoredDark(): boolean {
        try {
            return JSON.parse(window.localStorage[this.darkStorageKey] || 'false');
        } catch (e) {
            return false;
        }
    }

    onCustomChange(value: string) {
        this.customPrimary = value;
        const derivedAccent = this.lightenHex(this.customPrimary, 0.4);

        const oldTheme = this.getStoredTheme();
        this.removeTheme(oldTheme);
        this.injectCustomStyles(this.customPrimary, derivedAccent);
        const customTheme: Theme = {
            theme_name: 'custom',
            color: this.customPrimary,
            isDefault: false,
            isActive: false
        };
        this.applyTheme(customTheme);
        this.storeTheme(customTheme);
        this.storeCustom(this.customPrimary, derivedAccent);
    }

    injectCustomStyles(primary: string, accent: string) {
        const existing = document.getElementById('custom-theme-style');
        if (existing) existing.remove();

        const style = document.createElement('style');
        style.id = 'custom-theme-style';
        style.innerHTML = `
            .custom .mat-toolbar.mat-primary { background-color: ${primary} !important; }
            .custom .mat-raised-button.mat-primary,
            .custom .mat-flat-button.mat-primary,
            .custom .mat-fab.mat-primary,
            .custom .mat-mini-fab.mat-primary { background-color: ${primary} !important; color: white !important; }
            .custom .mat-checkbox-checked.mat-primary .mat-checkbox-background,
            .custom .mat-checkbox-indeterminate.mat-primary .mat-checkbox-background { background-color: ${primary} !important; }
            .custom .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle { border-color: ${primary} !important; }
            .custom .mat-radio-button.mat-primary .mat-radio-inner-circle { background-color: ${primary} !important; }
            .custom .mat-progress-bar-fill::after { background-color: ${primary} !important; }
            .custom .mat-tab-label.mat-tab-label-active { color: ${primary} !important; }
            .custom .mat-ink-bar { background-color: ${primary} !important; }
            .custom .mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-thumb { background-color: ${primary} !important; }
            .custom .mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-bar { background-color: ${primary}80 !important; }
            .custom .mat-form-field.mat-focused .mat-form-field-ripple { background-color: ${primary} !important; }
            .custom .mat-form-field.mat-focused .mat-form-field-label { color: ${primary} !important; }
            .custom .mat-raised-button.mat-accent,
            .custom .mat-flat-button.mat-accent { background-color: ${accent} !important; color: white !important; }
            .custom .mat-sidenav, 
            .custom .mat-drawer { background-color: ${this.lightenHex(primary, 0.6)} !important; }
            .custom .mat-sidenav-content,
            .custom .mat-drawer-content { background-color: ${this.lightenHex(primary, 0.8)} !important; }
            .custom .mat-checkbox.mat-accent.mat-checkbox-checked .mat-checkbox-background,
            .custom .mat-checkbox.mat-accent.mat-checkbox-indeterminate .mat-checkbox-background { background-color: ${accent} !important; }
            .custom .mat-checkbox.mat-accent .mat-checkbox-frame { border-color: ${accent} !important; }
            .custom .mat-form-field.mat-accent .mat-form-field-ripple { background-color: ${accent} !important; }
            .custom .mat-form-field.mat-accent.mat-focused .mat-form-field-label { color: ${accent} !important; }
            .custom .mat-select.mat-accent .mat-select-arrow { color: ${accent} !important; }
            .custom .mat-select.mat-accent.mat-focused .mat-select-trigger { color: ${accent} !important; }
            .custom .amd-card-header { background-color: ${primary} !important; color: white !important; }
        `;
        document.head.appendChild(style);
    }

    injectRainbowStyles() {
        const existing = document.getElementById('custom-theme-style');
        if (existing) existing.remove();

        const style = document.createElement('style');
        style.id = 'custom-theme-style';
        style.innerHTML = `
            @keyframes rainbow {
                10%  { background-color: #a43535; }
                20%  { background-color: #ff7b00; }
                30%  { background-color: #ffff51; }
                40%  { background-color: #a7ff4e; }
                50%  { background-color: #7addfe; }
                60%  { background-color: #6b6bfd; }
                70%  { background-color: #ca61ff; }
                80%  { background-color: #ff54af; }
                90%  { background-color: #f3bbff; }
            }
            .rainbow .mat-toolbar.mat-primary { animation: rainbow 20s ease-in-out infinite; }
            .rainbow .amd-card-header { animation: rainbow 20s ease-in-out infinite; color: white !important; }
            .rainbow .mat-sidenav,
            .rainbow .mat-drawer { animation: rainbow 25s ease-in-out infinite; }
            .rainbow .mat-ink-bar { animation: rainbow 20s ease-in-out infinite; }
            .rainbow .mat-tab-label.mat-tab-label-active { animation: rainbow 20s ease-in-out infinite; }
        `;
        document.head.appendChild(style);
    }

    isCustomActive(): boolean {
        const stored = this.getStoredTheme();
        return stored?.theme_name === 'custom';
    }

    lightenHex(hex: string, percent: number): string {
        const num = parseInt(hex.replace('#', ''), 16);
        const r = Math.min(255, Math.round((num >> 16) + (255 - (num >> 16)) * percent));
        const g = Math.min(255, Math.round(((num >> 8) & 0xff) + (255 - ((num >> 8) & 0xff)) * percent));
        const b = Math.min(255, Math.round((num & 0xff) + (255 - (num & 0xff)) * percent));
        return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    }

    storeCustom(primary: string, accent: string) {
        try {
            window.localStorage[this.customStorageKey] = JSON.stringify({ primary, accent });
        } catch (e) { }
    }

    getStoredCustom(): { primary: string, accent: string } {
        try {
            return JSON.parse(window.localStorage[this.customStorageKey] || null);
        } catch (e) {
            return null;
        }
    }

}
